export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    Console.error('[clipboard] Failed to copy:', err);
    return false;
  }
}
